import { TeamRole } from "entities/team-members/types/TeamRole"
import I18n from "i18n"
import z from "zod"

export const CreateTeamMemberInputSchema = z.object({
  email: z.email({ error: I18n.t("live:ValidationError.email") }),
  role: z.enum(TeamRole)
})

export type CreateTeamMemberInput = z.infer<typeof CreateTeamMemberInputSchema>
